// this is used for MobileListView
// TODO: rename to be more semantic (MobileDropdownMenu)

import React from 'react';
import cx from 'classnames';
import onClickOutside from 'react-click-outside';

// components
import MenuLabel from './components/MenuLabel';

// styles
import { StyledDropdownMenu } from './style';

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: React.ReactElement<any, any> | React.ReactNode;
  onClick?: () => void;
  isUserProfile?: boolean;
  title?: string;
}

interface State {
  isOpen: boolean;
}

class DropdownMenu extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }
  handleClickOutside() {
    this.setState({
      isOpen: false,
    });
  }
  handleClick = (e: React.SyntheticEvent) => {
    const { onClick } = this.props;
    if (onClick) {
      onClick();
    }

    e.stopPropagation();
    this.setState((state) => {
      return {
        isOpen: !state.isOpen,
      };
    });
  };
  render() {
    const { isOpen } = this.state;
    const { children, title } = this.props;
    const providedMenuLabel = React.Children.map(children, (elem: unknown) => {
      // @ts-ignore
      if (elem && elem.type.role && elem.type.role === 'menuLabel') return elem;
    });
    const menuLabelToDisplay =
      providedMenuLabel.length > 0 ? (
        // @ts-ignore
        React.cloneElement(providedMenuLabel[0], {
          onClick: this.handleClick,
          isOpen,
        })
      ) : (
        <MenuLabel isOpen={isOpen} onClick={this.handleClick} title={title} />
      );

    return (
      <StyledDropdownMenu className="DropdownMenu" onClick={this.handleClick}>
        {menuLabelToDisplay}

        <div className={cx('MenuBody-wrapper')}>
          {isOpen && (
            <>
              <div className="MenuBody-triangle" />
              <div
                className={cx('MenuBody', {
                  'MenuBody-isOpen': isOpen,
                })}
              >
                {
                  // @ts-ignore
                  React.Children.map(children, (item: React.ReactElement & { type: { role: string } }) => {
                    if (!item || (item.type.role && item.type.role === 'menuLabel')) return false;
                    const menuItemClassNames = item.props.divider ? 'MenuItem MenuItem-divider' : 'MenuItem';
                    return React.cloneElement(item, { className: menuItemClassNames });
                  })
                }
              </div>
            </>
          )}
        </div>
      </StyledDropdownMenu>
    );
  }
}

export default onClickOutside(DropdownMenu);
